import { render, staticRenderFns } from "./exportName.vue?vue&type=template&id=e920ac28&"
import script from "./exportName.vue?vue&type=script&lang=js&"
export * from "./exportName.vue?vue&type=script&lang=js&"
import style0 from "./exportName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports